import React, { useEffect, useRef } from 'react';
import SmartChartBridge from './SmartChartBridge';
import SmartChartNoData from './SmartChartNoData';
import SmartChartLifecycle from './SmartChartLifecycle';

type SmartChartLightWrapperProps = {
  onContainerReady?: (el: HTMLDivElement) => void;
};

// Renders SmartChart UI and provides a container for the lightweight chart engine
export default function SmartChartLightWrapper({ onContainerReady }: SmartChartLightWrapperProps) {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (containerRef.current) {
      const detail = { container: containerRef.current };
      window.dispatchEvent(new CustomEvent('lightweight:init', { detail }));
      if (onContainerReady) onContainerReady(containerRef.current);
    }
  }, [onContainerReady]);

  return (
    <div className="smartchart-light-wrapper" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <SmartChartBridge />
      <SmartChartLifecycle />
      {/* Render SmartChart UI only; data engine disabled via noop hooks. */}
      <SmartChartNoData />
      {/* Lightweight chart container mounted within SmartChart content area */}
      <div
        ref={containerRef}
        id="lightweight-chart-container"
        style={{ flex: 1, minHeight: 300 }}
      />
    </div>
  );
}
